import axios from 'axios';

import API from '../API/ApiURL';
import store from '../store';
import { normalizarError } from '../utils/errorHandlerUtil';

const axiosNode = axios.create({
  baseURL: API.serverUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosNode.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  const apiKeyServer = API.apiKeyServer;

  if (token) {
    config.headers.Token = token;
  }

  if (apiKeyServer) {
    config.headers['x-api-key'] = apiKeyServer;
  }

  return config;
});

axiosNode.interceptors.response.use(response => response, normalizarError);

const axiosAnonymous = axios.create({
  baseURL: API.serverUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosAnonymous.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  const apiKeyAbierta = API.apiKeyAbierta;

  if (apiKeyAbierta) {
    config.headers['api-key-anonymous'] = apiKeyAbierta;
  }

  if (token) {
    config.headers.Token = token;
  }

  return config;
});

const axiosGeneric = axios.create({
  baseURL: API.generic,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosGeneric.interceptors.request.use(config => {
  const tokenAPI = store.state.tokenAPI;

  if (tokenAPI) {
    config.headers.Authorization = tokenAPI;
  }

  return config;
});

export { axiosAnonymous, axiosGeneric, axiosNode };
